/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { createAsyncThunk } from "@reduxjs/toolkit";
import { User } from "./types";
import { config } from "../../../AppConfig/config";


/** Fetches all Argos users */
export const fetchUsers = createAsyncThunk('users/fetchUsers', async (idToken: string) => {
  const fetchUsersUrl = `${config.url.API_URL}/HttpTriggerUsers?req=fetchUsers`
  const response = await fetch(fetchUsersUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${idToken}`
    },
  })
  if (!response.ok) {
    throw new Error('Failed to fetch users')
  }
  return (await response.json()) as User[]
})
